import { observer } from 'mobx-react-lite';
import NavbarEU from '../menu-bar-eu/NavbarEU';

export default observer(function HeaderForGeneral() {
    return (
        <NavbarEU />
    );
});
